










































































































import Vue, { PropType } from 'vue'
import ActorMiniature from './ActorMiniature.vue'
import { Video } from '../../../PeerTube/shared/models'
import { durationToString } from '../shared/utils'
import { renderMarkdown } from '../shared/markdown-render'

export default Vue.extend({
  components: {
    'actor-miniature': ActorMiniature
  },

  props: {
    video: Object as PropType<Video>
  },

  computed: {
    host () {
      const url = this.video.url

      return new URL(url as string).host
    },

    formattedDuration () {
      return durationToString(this.video.duration)
    },

    windowWidth () {
      return window.innerWidth
    },

    publicationDate () {
      return new Date(this.video.publishedAt).toLocaleDateString()
    },

    watchVideoMessage () {
      return this.$gettextInterpolate(this.$gettext('Watch the video on %{host}'), { host: this.host })
    }
  },

  methods: {
    getVideoThumbnailUrl () {
      if (this.windowWidth >= 900) {
        return this.video.thumbnailUrl
      }

      return this.video.previewUrl
    },
    renderMarkdown(markdown: string) {
        return renderMarkdown(markdown)
    }
  }
})
